import { TCoreTextStyleProps } from '@core/widgets';

type TTextStyle = {
    display1: TCoreTextStyleProps;
    display2: TCoreTextStyleProps;
    header: TCoreTextStyleProps;
    subheader: TCoreTextStyleProps;
    main: TCoreTextStyleProps;
    mCardNo: TCoreTextStyleProps;
    secondary: TCoreTextStyleProps;
    tag: TCoreTextStyleProps;
};

export type TSeparatorVariant = 'line' | 'subheader';

export type TSeparatorHierarchy = 'primary' | 'secondary';

export const TextStyle: TTextStyle = {
    display1: {
        font: 'var(--font-display1)',
        fontStyle: {
            fontSize: 'var(--text-display1-size)',
            fontWeight: 'var(--text-display1-weight)',
            lineHeight: 'var(--text-display1-line-height)',
            letterSpacing: 'var(--text-display1-spacing)',
        },
    },
    display2: {
        font: 'var(--font-display2)',
        fontStyle: {
            fontSize: 'var(--text-display2-size)',
            fontWeight: 'var(--text-display2-weight)',
            lineHeight: 'var(--text-display2-line-height)',
            letterSpacing: 'var(--text-display2-spacing)',
        },
    },
    header: {
        font: 'var(--font-header)',
        fontStyle: {
            fontSize: 'var(--text-header-size)',
            fontWeight: 'var(--text-header-weight)',
            lineHeight: 'var(--text-header-line-height)',
            letterSpacing: 'var(--text-header-spacing)',
        },
    },
    subheader: {
        font: 'var(--font-subheader)',
        fontStyle: {
            fontSize: 'var(--text-subheader-size)',
            fontWeight: 'var(--text-subheader-weight)',
            lineHeight: 'var(--text-subheader-line-height)',
            letterSpacing: 'var(--text-subheader-spacing)',
        },
    },
    main: {
        font: 'var(--font-main)',
        fontStyle: {
            fontSize: 'var(--text-main-size)',
            fontWeight: 'var(--text-main-weight)',
            lineHeight: 'var(--text-main-line-height)',
            letterSpacing: 'var(--text-main-spacing)',
        },
    },
    mCardNo: {
        font: 'var(--font-mCardNo)',
        fontStyle: {
            fontSize: 'var(--text-mCardNo-size)',
            fontWeight: 'var(--text-mCardNo-weight)',
            lineHeight: 'var(--text-mCardNo-line-height)',
            letterSpacing: 'var(--text-mCardNo-spacing)',
        },
    },
    secondary: {
        font: 'var(--font-secondary)',
        fontStyle: {
            fontSize: 'var(--text-secondary-size)',
            fontWeight: 'var(--text-secondary-weight)',
            lineHeight: 'var(--text-secondary-line-height)',
            letterSpacing: 'var(--text-secondary-spacing)',
        },
    },
    tag: {
        font: 'var(--font-tag)',
        fontStyle: {
            fontSize: 'var(--text-tag-size)',
            fontWeight: 'var(--text-tag-weight)',
            lineHeight: 'var(--text-tag-line-height)',
            letterSpacing: 'var(--text-tag-spacing)',
        },
    },
};
